import Vue from "vue";
import VueRouter from "vue-router";
import { canNavigate, _ } from "@/plugins/acl/routeProtection";
import generalRoutes from "@/router/general";
import ctcRoutes from "@/router/ctc";
import programmatiqueRoutes from "@/router/programmatique";
import audienceRoutes from "@/router/audience";
import arbitrageRoutes from "@/router/acquisition";
import seoRoutes from "@/router/seo";
import regieRoutes from "@/router/regie";
import adminRoutes from "@/router/admin";
import crmRoutes from "@/router/crm";
import financeRoutes from "@/router/finance";
import googleDiscoverRoutes from "@/router/googleDiscover";
import partnerRoutes from "@/router/partners";
import rmrAnalyticsRoutes from "@/router/rmrAnalytics";
import usersRoutes from "@/router/users";
import devRoutes from "@/router/dev";
import LinkMessagingAppsRoute from "@/router/linkMessagingApps";
import webPerfRoutes from "@/router/webPerf";
import gTrendsRoutes from "@/router/gTrends";
import newsRadarRoute from "@/router/newsRadar";
import aiFactory from "@/router/aiFactory";
import marketingRoutes from "@/router/marketing";
import geoRoutes from "@/router/geo";
import autoEmailReportRoutes from "@/router/autoEmailReport";


Vue.use(VueRouter);

const routes = [
  ...generalRoutes,
  ...ctcRoutes,
  ...programmatiqueRoutes,
  ...audienceRoutes,
  ...regieRoutes,
  ...devRoutes,

  ...arbitrageRoutes,
  ...seoRoutes,
  ...googleDiscoverRoutes,
  ...rmrAnalyticsRoutes,
  ...financeRoutes,
  ...adminRoutes,
  ...crmRoutes,
  ...usersRoutes,
  ...LinkMessagingAppsRoute,
  ...webPerfRoutes,
  ...gTrendsRoutes,
  ...partnerRoutes,
  ...newsRadarRoute,
  ...aiFactory,
  ...marketingRoutes,
  ...geoRoutes,
  ...autoEmailReportRoutes,

  {
    path: "/marmiton/visitors-info",
    name: "marmiton-visitors",
    component: () => import("@/views/regie/VisitorsInfo.vue"),
    props: {
      department: "marmiton",
    },
    meta: {
      layout: "content",
      resource: "marmiton",
      action: "manage",
      rmrAnalytics: {
        track: true,
        eventType: "marmiton-visitors-info",
        eventCategory: "page-view",
      },
    },
  },

  {
    path: "/login",
    name: "auth-login",
    component: () => import("@/views/Login.vue"),
    meta: {
      layout: "blank",
    },
  },
  {
    path: "/notifications",
    name: "notifications",
    component: () => import("@/views/pages/Notifications.vue"),
    meta: {
      layout: "content",
      resource: "general",
      action: "manage",
      rmrAnalytics: {
        track: true,
        eventType: "notifications",
        eventCategory: "page-view",
      },
    },
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: () => import("@/views/pages/static/PrivacyPolicy.vue"),
    meta: {
      layout: "blank",
      rmrAnalytics: {
        track: true,
        eventType: "privacy-policy",
        eventCategory: "page-view",
      },
    },
  },
  {
    path: "/public-terms-of-service",
    name: "public-terms-of-service",
    component: () => import("@/views/pages/static/PublicTermsOfService.vue"),
    meta: {
      layout: "blank",
      rmrAnalytics: {
        track: true,
        eventType: "public-terms-of-service",
        eventCategory: "page-view",
      },
    },
  },
  {
    path: "/changelog",
    name: "changelog",
    component: () => import("@/views/pages/static/Changelog.vue"),
    meta: {
      layout: "content",
      resource: "general",
      action: "manage",
      rmrAnalytics: {
        track: true,
        eventType: "changelog",
        eventCategory: "page-view",
      },
    },
  },
  {
    path: "/ga-via-js-test",
    name: "ga-via-js-test",
    component: () => import("@/views/pages/static/GaViaJsTest.vue"),
    meta: {
      layout: "content",
    },
  },
  {
    path: "/test",
    name: "test",
    component: () =>
      import("@/views/partners/partner-view/components/DimensionInline"),
    meta: {
      layout: "content",
    },
  },
  {
    path: "/not-authorized",
    name: "not-authorized",
    component: () => import("@/views/NotAuthorized.vue"),
    meta: {
      layout: "blank",
      resource: "Public",
    },
  },
  {
    path: "*",
    redirect: "error-404",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
      //Or for Vue 3:
      //return {el: to.hash}
    }

    if (savedPosition) {
      return savedPosition;
    }

    return { x: 0, y: 0 };
  },
});

// ? Router Before Each hook: https://router.vuejs.org/guide/advanced/navigation-guards.html
router.beforeEach((to, _, next) => {
  const allowedRoutes = [
    "auth-login",
    "not-authorized",
    "notifications",
    "alert-system-edit",
    "privacy-policy",
    "public-terms-of-service",
  ];

  if (allowedRoutes.includes(to.name)) {
    return next();
  }

  const isLoggedIn =
    localStorage.getItem("accessToken") && localStorage.getItem("userAbility");

  if (!canNavigate(to)) {
    if (!isLoggedIn)
      return next({
        name: "auth-login",
      });

    return next({ name: "not-authorized" });
  }

  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    next("/");
  }

  return next();
});

export default router;
